import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import HeadTitle from 'src/components/atoms/HeadTitle'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import inquiryImg from 'src/images/partner/howto/inquiry.png'
import getInfoImg from 'src/images/partner/howto/get-info.png'
import startImg from 'src/images/partner/howto/start.png'

export const PartnerHowto= () => {
    return (
        <Container>
            <ContentsWrapper>
            <HeadingBorder heading="REGISTER" />
            <HeadTitle>パートナー登録までの流れ</HeadTitle>
            <ColumnWrapper>
                <Column>
                    <Title as="h3">1.カレンダーより日程調整</Title>
                    <VectorImage src={inquiryImg} alt="問い合わせ" />
                </Column>
                <Column>
                    <Title as="h3">2.弊社担当とのお打ち合わせ</Title>
                    <VectorImage src={getInfoImg} alt="弊社担当より連絡" />
                </Column>
                <Column>
                    <Title as="h3">3.契約開始</Title>
                    <VectorImage src={startImg} alt="契約開始" />
                </Column>
            </ColumnWrapper>
            </ContentsWrapper>
        </Container>
    )
}

const Container = styled.div`
    background-color: ${Styles.color.primary[200]};
    padding: 48px 0;
`

const ColumnWrapper= styled.div`
    padding: 0 0 ${Styles.spacing[11]};
    max-width: 990px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: ${Styles.spacing[10]};
    text-align: center;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        padding: 0 30px ${Styles.spacing[13]};
        flex-direction: row;
    }
`

const Column = styled.div`

`

const Title = styled.div`
    color: ${Styles.color.primary[400]};
    font-size: ${Styles.fontSize[400]};
    font-weight: ${Styles.fontWeight.bold};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        font-size: ${Styles.fontSize[500]};
        flex: 1;
        min-width: 0;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
    }
`

const VectorImage = styled.img`
    height: auto;
    align-self: flex-start;
    margin: calc(${Styles.spacing[4]} * -1) 0 0 calc(${Styles.spacing[4]} * -1);
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        margin: 0 0 0 calc(${Styles.spacing[4]} * -1);
        max-width: 70%;
    }
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        margin: 0;
        max-width: 80%;
    }
`